import React, { cloneElement } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { Provider } from 'react-redux';
import Modal from './Modal';

// because it is returning the result as a promise it should really be called resolveModal rather than openModal
export default function openModal(modalReactElement, {store, title, icon, hasCancel = true}) {
	var modalNode = document.createElement('div');
	document.body.appendChild(modalNode);
	modalNode.classList.add('c3-modal-root');

	return new Promise((resolve, reject) => {
		var onComplete = (confirmData = true) => {
			resolve(confirmData)
			unmountComponentAtNode(modalNode);
			modalNode.remove();
		};

		var onCancel = () => {
			resolve(false);
			unmountComponentAtNode(modalNode);
			modalNode.remove();
		};

		var ModalElementWithProps = cloneElement(modalReactElement, {onCancel, onComplete}); 

		var composed = (
			<Provider store={store}>
				<Modal onCancel={onCancel} title={title} icon={icon} hasCancel={hasCancel}>
					{ModalElementWithProps}
				</Modal>
			</Provider>
		);

		render(composed, modalNode);
    });
}


// WEBPACK FOOTER //
// ./app/c3/modal/openModal.js